export { default as WysiwygInput } from './WysiwygInput.vue';
export var WysiwygInputHeight;
(function (WysiwygInputHeight) {
    WysiwygInputHeight["ONE_LINE"] = "one-line-wysiwyg";
    WysiwygInputHeight["TEXTAREA"] = "textarea-wysiwyg";
})(WysiwygInputHeight || (WysiwygInputHeight = {}));
